import React, { useEffect, useState } from "react";
import axios from "axios";
import TestimonioForm from "./TestimonioForm";

const StarRating = ({ rate }) => {
  const stars = parseInt(rate) || 0;
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <svg
          key={i}
          className={`w-4 h-4 ${i <= stars ? "text-warm" : "text-gray-200"}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
};

const avatarColors = [
  "bg-primary text-white",
  "bg-ocean text-white",
  "bg-warm text-white",
  "bg-mint text-white",
  "bg-primary-light text-white",
];

export default function Testimonios() {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    axios
      .get("https://backend-bzt-production.up.railway.app/api/comment/findAll/bczt96")
      .then((res) => {
        setComments(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <section className="bg-white overflow-hidden" id="testimonios">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-warm-lighter text-warm font-body font-semibold text-sm px-4 py-1.5 rounded-full mb-3">
            Lo que dicen
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">
            Testimonios
          </h2>
          <p className="mt-3 text-gray-500 font-body text-base max-w-lg mx-auto">
            La experiencia de familias y pacientes que han trabajado con Barbara
          </p>
        </div>

        {comments.length > 0 ? (
          <div className="grid md:grid-cols-2 gap-6 mb-16">
            {comments.map((c, index) => (
              <div
                key={index}
                className="group bg-white border-2 border-gray-100 hover:border-primary/30 rounded-3xl p-6 shadow-soft hover:shadow-soft-lg transition-all duration-300"
              >
                {/* Quote icon */}
                <div className="w-10 h-10 bg-primary-lighter rounded-2xl flex items-center justify-center mb-4">
                  <svg className="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 975.036 975.036">
                    <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
                  </svg>
                </div>

                {/* Comment */}
                <p className="text-gray-600 font-body text-base leading-relaxed mb-5">
                  {c.comment}
                </p>

                {/* Footer */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <div className={`w-10 h-10 rounded-2xl flex items-center justify-center font-heading font-semibold text-sm flex-shrink-0 ${avatarColors[index % avatarColors.length]}`}>
                    {c.name ? c.name.charAt(0).toUpperCase() : "?"}
                  </div>
                  <div>
                    <p className="font-heading font-semibold text-gray-800 text-sm">{c.name}</p>
                    <StarRating rate={c.rate} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 mb-16">
            <div className="w-16 h-16 bg-primary-lighter rounded-3xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <p className="font-heading text-gray-500 text-lg">Sé el primero en dejar tu comentario</p>
          </div>
        )}

        <TestimonioForm />
      </div>

      {/* Wave */}
      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,20 C480,60 960,0 1440,40 L1440,60 L0,60 Z" fill="#EEF2FF" />
        </svg>
      </div>
    </section>
  );
}
